import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum RankingAction {
	Delete = 'delete',
	Duplicate = 'duplicate',
}

export interface IRankingActionModalData {
	rankingId: number | Array<number>;
	element: string;
	action: RankingAction;
}
@Component({
	selector: 'app-ranking-action-popup',
	templateUrl: './ranking-action-popup.component.html',
	styleUrls: ['./ranking-action-popup.component.scss'],
})
export class RankingActionPopupComponent<
	T extends IRankingActionModalData
> extends DcBaseComponent {
	protected readonly DcIcons = DcIcons;
	protected readonly RankingAction = RankingAction;
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		rankingId: number | Array<number>;
		isMultipleElement: boolean;
		action: RankingAction;
	}>;
	public confirmDeletion = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'ranking-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.rankingId) &&
				this.modalData.element === '',
			rankingId: this.modalData.rankingId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
